import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { DetalleCobranza } from '../components/InformesCobranza/DetalleCobranza/DetalleCobranza';
import TitleUpdater from '../components/TitleUpdater';
import { Loader } from '../components/Utils/Loader/Loader';

const DetalleCobranzaPage = () => {
    const { sCre_SolicitudWeb } = useParams();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState(null);

    useEffect(() => {
        // Recuperar los datos desde localStorage
        const storedData = localStorage.getItem('detalleCobranzaData');
        if (storedData) {
            try {
                const parsed = JSON.parse(storedData);
                // Verificar que el sCre_SolicitudWeb coincide con el de la ruta
                if (parsed.row && parsed.row.sCre_SolicitudWeb && parsed.row.sCre_SolicitudWeb.toString() === sCre_SolicitudWeb) {
                    setPageData(parsed);
                } else {
                    console.error("sCre_SolicitudWeb no coincide con los datos almacenados.");
                }
            } catch (e) {
                console.error("Error al parsear detalleCobranzaData", e);
            }
        }
    }, [sCre_SolicitudWeb]);

    if (!pageData) {
        return <Loader />;
    }

    return (
        <div className="min-h-screen bg-slate-100 p-4 md:p-6">
            <TitleUpdater title={`Detalle #${pageData.row.idCompra} - POINT`} />
            <DetalleCobranza
                isOpen={true}
                onClose={() => window.close()} // Cerrar la pestaña
                data={pageData.row}
                estadoGestion={pageData.estadoGestion}
                item={pageData.row}
                isPage={true}
            />
        </div>
    );
};

export default DetalleCobranzaPage;
